import { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import FeaturesDisplay from '../DDM/FeaturesDisplay';

export default class NewOffersRAM extends Component {
  lowerCasedBadge(badge) {
    return badge.toLowerCase();
  }

  compareTitles(title, subtitle) {
    const areStringsEqual = title === subtitle;

    return areStringsEqual ? '' : subtitle;
  }

  render() {
    const {
      title,
      subtitle,
      image,
      link,
      lazy,
      sealList,
      offer,
      showBadge,
      badge,
      onClickCard,
      ctaText,
    } = this.props;

    const {
      secondary_call,
      main_call,
      featured,
      description,
      features,
      show_features_list,
    } = offer;

    const limitedSealList = sealList.slice(0, 3);

    return (
      <div className="new-offers-card">
        <a className="new-offers-card__link" href={link} onClick={onClickCard}>
          <img
            className={classNames('new-offers-card__image', {
              'swiper-lazy': lazy,
            })}
            src={image}
            alt={title}
            width="200"
            height="145"
          />
        </a>
        <div className="new-offers-card__content">
          <div
            className="new-offers-card__content-header"
            data-match-height="new-offers-card__content-header"
          >
            <h3 className="new-offers-card__title">{title}</h3>
            <h4 className="new-offers-card__subtitle">
              {this.compareTitles(title, subtitle)}
            </h4>
          </div>

          <ul
            className="new-offers-card__highlights"
            data-match-height="new-offers-card__highlights"
          >
            {limitedSealList.map(item => (
              <li className="new-offers-card__highlight">
                <i className="icon icon-chevron" />
                {item}
              </li>
            ))}
          </ul>
          <div
            className="new-offers-card__price"
            data-match-height="new-offers-card__price"
          >
            {secondary_call && (
              <p className="new-offers-card__starting-price">
                {secondary_call}
              </p>
            )}
            {main_call && (
              <small className="new-offers-card__text-by">{main_call}</small>
            )}
            {featured && (
              <div className="new-offers-card__promotional-price">
                {featured}
              </div>
            )}
            {description && (
              <div className="new-offers-card__description">{description}</div>
            )}

            {show_features_list && features && (
              <FeaturesDisplay features={features} />
            )}
          </div>
          <a
            className="btn button button--large button--primary"
            href={link}
            onClick={onClickCard}
          >
            {ctaText}
          </a>
        </div>

        {showBadge && (
          <div className="new-offers-card__badge">
            <small>{this.lowerCasedBadge(badge)}</small>
          </div>
        )}
      </div>
    );
  }
}

NewOffersRAM.defaultProps = {
  title: '',
  subtitle: '',
  image: '',
  link: '',
  lazy: false,
  sealList: [],
  offer: {},
  showBadge: false,
  badge: '',
  ctaText: 'Tenho interesse',
  onClickCard: () => {},
};

NewOffersRAM.propTypes = {
  title: PropTypes.string,
  subtitle: PropTypes.string,
  image: PropTypes.string,
  link: PropTypes.string,
  sealList: PropTypes.arrayOf(PropTypes.string),
  lazy: PropTypes.bool,
  offer: PropTypes.shape({
    secondary_call: PropTypes.string,
    main_call: PropTypes.string,
    featured: PropTypes.string,
    description: PropTypes.string,
    features: PropTypes.arrayOf(PropTypes.string),
    show_features_list: PropTypes.bool,
  }),
  showBadge: PropTypes.bool,
  badge: PropTypes.string,
  ctaText: PropTypes.string,
  onClickCard: PropTypes.func,
};
